import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseRounded = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.3723 15.3723C16.9982 13.7464 18 11.4799 18 9C18 6.52007 16.9982 4.27007 15.3723 2.64416C13.7464 1.00182 11.4799 0 9 0C6.52007 0 4.27007 1.00182 2.64416 2.64416C1.00182 4.27007 0 6.52007 0 9C0 11.4799 1.00182 13.7464 2.64416 15.3723C4.27007 16.9982 6.52007 18 9 18C11.4799 18 13.7464 16.9982 15.3723 15.3723ZM10.7409 12.4818L9 10.7409L7.25912 12.4818C6.94708 12.7938 6.42153 12.7938 6.10949 12.4818L5.53467 11.8905C5.2062 11.5785 5.2062 11.0529 5.53467 10.7409L7.25912 9L5.53467 7.25912C5.2062 6.94708 5.2062 6.42153 5.53467 6.10949L6.10949 5.53467C6.42153 5.2062 6.94708 5.2062 7.25912 5.53467L9 7.25912L10.7409 5.53467C11.0529 5.2062 11.5785 5.2062 11.8905 5.53467L12.4818 6.10949C12.7938 6.42153 12.7938 6.94708 12.4818 7.25912L10.7409 9L12.4818 10.7409C12.7938 11.0529 12.7938 11.5785 12.4818 11.8905L11.8905 12.4818C11.5785 12.7938 11.0529 12.7938 10.7409 12.4818Z",
		fill: "white"
	})
});
export default SvgCloseRounded;
